<template>
  <div class="body-max-width">
    <div class="body-max-width">
      <Header title="Flash Sale 12.12"></Header>
    </div>
    <img
      v-if="lang == 'en'"
      src="https://superappamplify606fa1d85f814bb18faa753d121e9fb4113101-uat.s3.ap-southeast-1.amazonaws.com/backoffice/poc/3 Small Banner ENG.png_1701935682617.image/png"
      style="width: 100%"
    />
    <img
      v-else
      src="https://superappamplify606fa1d85f814bb18faa753d121e9fb4113101-uat.s3.ap-southeast-1.amazonaws.com/backoffice/poc/3 Small Banner.png_1701935704569.image/png"
      style="width: 100%"
    />
    <div class="body-max-width">
      <div class="text-box">
        <p class="title">{{ $t("flashSale") }}</p>
        <p class="detail">{{ $t("sukhumvit") }}</p>
        <p class="detail">{{ $t("srinakarin") }}</p>
        <p class="detail">{{ $t("flashSaleDesc") }}</p>
        <!-- <p class="detail-2" style="word-break: break-word;">{{ $t("flashSaleDesc2") }}</p> -->
        <p class="detail-2" style="word-break: break-word">
          {{ $t("flashSaleDesc2") }}
        </p>
        <p class="detail-2" style="word-break: break-word">
          {{ $t("flashSaleDesc3") }}
        </p>
      </div>
      <button class="button-reserve flex-mid" @click="gotoTotalHealth">
        {{ $t("gotoHealthPackages") }}
      </button>
      <div class="remark">
        <p class="detail-2" style="word-break: break-word">
          {{ $t("flashSaleRemark") }}
        </p>
        <p class="detail-2" style="word-break: break-word">
          {{ $t("flashSaleRemark2") }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import axios from "axios";
import Header from "@/components/HomeNav.vue";
export default defineComponent({
  name: "FlashSalePage",
  components: {
    Header,
  },
  data() {
    return {
      lang: "th",
      accessToken: null,
      flashSaleDay: false,
      month: 0,
      date: 0,
    };
  },
  mounted() {
    this.accessToken = this.$cookies.get("access_token");
    this.lang = this.$cookies.get("lang");
    this.checkDate();
  },
  methods: {
    checkDate() {
      const date = new Date("2023-12-12");

      let dateNow = date.getDate();
      let monthNow = date.getMonth() + 1;
      if (dateNow == monthNow) {
        this.flashSaleDay = true;
      }
      console.log("dateNow", date);
      console.log("date", dateNow, monthNow, this.flashSaleDay);
      this.month = monthNow;
      this.date = dateNow;
      // check date and month order is equal
    },
    gotoTotalHealth() {
      this.$router.push({ path: "/" });
    },
  },
});
</script>

<style lang="scss" scoped>
.text-box {
  margin-top: 50px;
  margin-bottom: 20px;
  text-align: center;

  .title {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 10px;
    color: #2c686c;
  }

  .detail {
    font-size: 18px;
    margin-bottom: 10px;
  }

  .detail-2 {
    font-size: 16px;
    // margin-bottom: 10px;
  }
}

.button-reserve {
  background: #6db557;
  color: #ffffff;
  border: none;
  // width: 100px;
  height: 50px;
  border-radius: 10px;
  font-size: 18px;
  margin: 3rem auto;
  padding: 1rem;
  text-align: center;
  // align-items: center;
}

.remark {
  width: 100%;

  .detail-2 {
    font-size: 14px;
    // margin-bottom: 10px;
  }
}
</style>
